export const ROOT = '/';
export const RELATIONSHIPS = '/relationships';
export const PEOPLE = '/people';
export const ORGANIZATIONS = '/organizations';
export const LOTS_GARAGES = '/lots-garages';
export const ORGANIZATIONS_TREE = '/tree';
